
export class ResultadoSeicep {
    idResultado !: number;
    numeroRespuestasCorrectas !: number;
    puntajeComponente1 !: number;
    ponderadoComponente1 !: number;
    finalComponente1 !: number;
    puntajeComponente2 !: number;
    ponderadoComponente2 !: number;
    finalComponente2 !: number;
    puntajeComponente3 !: number;
    ponderadoComponente3 !: number;
    finalComponente3 !: number;
    totalFinal !: number;
    tramo !: number;
    componente21 !: number;
    componente22 !: number;
    componente23 !: number;
    componente31 !: number;
    componente32 !: number;
    componente33 !: number;
}
